<h1 mat-dialog-title i18n>Legal document</h1>
<div mat-dialog-content class="main-content px-2">
	<div class="custom-table my-3 mx-2">
		<div class="row custom-table-header main-header">
			<div class="col align-self-center">
				<span class="title" i18n>Versions</span>
			</div>

			<div class="col mr-1 align-self-center text-right">
				<div class="d-inline-block mr-4" *ngIf="localisations.length > 0">
					<mat-select auto class="text-right app-legal-edit__localisation" [formControl]="localisationSelector" style="width: auto">
						<mat-select-trigger class="pr-1">
							<ng-container *ngIf="localisationSelector.value; else localisationNotSelected">{{ localisationSelector.value.code }}</ng-container>
							<ng-template #localisationNotSelected i18n>Locale</ng-template>
						</mat-select-trigger>
						<mat-option value="">Default</mat-option>
						<mat-option *ngFor="let locale of localisations" [value]="locale">{{locale.name}}</mat-option>
					</mat-select>
				</div>

				<mat-select auto class="text-right app-legal-edit__version" [formControl]="versionSelector" style="width: auto">
					<mat-select-trigger class="pr-1">{{ versionSelector.value.label }}</mat-select-trigger>
					<mat-option *ngFor="let version of versions" [value]="version">
						<div class="text-right">
							<span class="option-label float-left">{{version.label}}</span>
							<span class="badge badge-pill px-3 ml-2 py-1 status-badge {{version.badge}}">{{version.stateLabel}}</span>
						</div>
					</mat-option>
				</mat-select>
			</div>

			<div class="col-sm-auto pl-0" *ngIf="isAdmin">
				<button
					type="button"
					mat-icon-button
					[matMenuTriggerFor]="legalActionMenu"
					class="btn-sm small-btn app-legal-edit__edit-actions"
				>
					<mat-icon class="material-icons">more_vert</mat-icon>
				</button>
				<mat-menu #legalActionMenu="matMenu">
					<button mat-menu-item i18n title="Add document" i18n-title (click)="uploadTerm()" class="app_legal__add">
						Add version
					</button>
					<button mat-menu-item i18n title="Update document" i18n-title (click)="updateTerm()" class="app_legal__update">
						Update document
					</button>
					<button
						mat-menu-item
						i18n
						title="Delete document"
						i18n-title
						*ngIf="!dialogData.terms?.activeVersion"
						(click)="confirmDeleteTerm()"
						class="app_legal__delete"
					>
						Delete document
					</button>
					<button
						mat-menu-item
						i18n
						title="View Associated app keys"
						i18n-title
						(click)="viewAppKeyAssociation()"
						class="app_legal__app-keys"
					>
						View associated app keys
					</button>
				</mat-menu>
			</div>
		</div>
		<form [formGroup]="versionSelector">
			<div class="custom-table-body">
				<div class="row align-items-center mx-0 px-1 custom-table-item">
					<div class="col">
						<div class="document-name mb-1 app_legal__name">
							<ng-container *ngIf="!localisationSelector.value; else localisedDisplayName">{{dialogData.terms.displayName}}</ng-container>
							<ng-template #localisedDisplayName>{{dialogData.terms.displayNames[localisationSelector.value.code]}}</ng-template>
						</div>
						<div class="contact-name" *ngIf="dialogData.terms?.alias">
							<span class="pr-1" i18n>Alias:</span>
							<button
								title="Copy alias to clipboard."
								[appCopyToClipboard]="dialogData.terms.alias"
								[appCopyToClipboardIcon]="true"
								i18n-title
								type="button"
								class="button-link app_legal__alias"
							>
								{{ dialogData.terms.alias }}
							</button>
						</div>

						<div class="contact-name" *ngIf="dialogData.terms.documents[versionSelector.value.key]?.publishedBy; else createdBy">
							<span class="pr-1" i18n>Published by:</span>
							<span>
								<a
									href="mailto:{{ dialogData.terms.documents[versionSelector.value.key].publishedBy.email }}"
									class="mr-1"
									style="font-weight: 400"
									>{{ dialogData.terms.documents[versionSelector.value.key].publishedBy.firstName + ' ' +
									dialogData.terms.documents[versionSelector.value.key].publishedBy.lastName }}</a
								>
								<span class="document-date" i18n
									>at {{ dialogData.terms.documents[versionSelector.value.key].publishedBy.ts | date: 'medium' }}</span
								>
							</span>
						</div>

						<ng-template #createdBy>
							<div class="contact-name" *ngIf="dialogData.terms.documents[versionSelector.value.key]?.createdBy">
								<span class="pr-1" i18n>Created by:</span>
								<span>
									<a
										href="mailto:{{ dialogData.terms.documents[versionSelector.value.key].createdBy.email }}"
										class="mr-1"
										style="font-weight: 400;"
									>{{ dialogData.terms.documents[versionSelector.value.key].createdBy.firstName + ' ' + dialogData.terms.documents[versionSelector.value.key].createdBy.lastName }}</a>
									<span class="document-date" i18n>at {{ dialogData.terms.documents[versionSelector.value.key].createdBy.ts | date: 'medium' }}</span>
								</span>
							</div>
						</ng-template>
					</div>

					<div class="col-sm-auto small-btn">
						<span
							class="badge badge-pill pl-3 py-1 mr-2 status-badge disabled pr-3 {{ versionSelector.value.badge }}"
							*ngIf="!isAdmin || versionSelector.value.state !== termStates.draft"
							>{{ versionSelector.value.stateLabel }}</span
						>

						<button
							(click)="confirmPublishTerm(versionSelector.value.key)"
							*ngIf="versionSelector.value.state === termStates.draft && (versionSelector.value.key > dialogData.terms.activeVersion || !dialogData.terms?.activeVersion)"
							class="border-0 badge badge-pill badge-warning pl-3 py-1 mr-2"
							title="Publish version"
							i18n-title
							[disabled]="!isAdmin"
							i18n
						>
							publish draft
							<span class="material-icons pl-2 align-middle" style="font-size: 12px !important">update</span>
						</button>

						<span
							class="badge badge-pill badge-warning status-badge disabled px-3 py-1 mr-2"
							*ngIf="versionSelector.value.state === termStates.draft && (dialogData.terms?.activeVersion && versionSelector.value.key < dialogData.terms.activeVersion)"
							title="Draft version"
							i18n-title
							i18n
							>draft</span
						>

						<button
							class="btn btn-transparent"
							type="button"
							(click)="viewTerms(versionSelector.value.key)"
							title="View version"
							i18n-title
						>
							<span class="material-icons align-middle">remove_red_eye</span>
						</button>

						<button
							type="button"
							mat-icon-button
							[matMenuTriggerFor]="legalDetailsActionMenu"
							class="app-legal-edit__actions"
						>
							<mat-icon class="material-icons">more_vert</mat-icon>
						</button>
						<mat-menu #legalDetailsActionMenu="matMenu">
							<button
								mat-menu-item
								i18n
								title="View"
								i18n-title
								(click)="viewTerms(versionSelector.value.key)"
							>View</button>
							<button
								mat-menu-item
								i18n
								title="Publish"
								i18n-title
								(click)="confirmPublishTerm(versionSelector.value.key)"
								*ngIf="isAdmin && versionSelector.value.state === termStates.draft && (versionSelector.value.key > dialogData.terms.activeVersion || !dialogData.terms?.activeVersion)"
								class="app-legal-edit__publish"
							>Publish</button>
							<button
								mat-menu-item
								i18n
								title="Delete"
								i18n-title
								*ngIf="isAdmin && versionSelector.value.state === termStates.draft"
								(click)="confirmDeleteTerm(versionSelector.value.key)"
								class="app-legal-edit__delete"
							>Delete</button>
						</mat-menu>
					</div>
				</div>
			</div>
		</form>
	</div>
</div>
<div mat-dialog-actions class="row justify-content-md-center mb-0">
	<div class="col-6 align-self-end text-center">
		<button class="w-100" mat-flat-button mat-dialog-close i18n>Done</button>
	</div>
</div>
